export default "__VITE_ASSET__qS0DCYwd__"